import React from 'react';
import { PlatformPrivileges } from '../../types.generated';
import { AccessRestrictedBlock } from './AccessRestrictedBlock';
import { useUserContext } from '../context/useUserContext';

interface Props {
    isRestricted: (privileges: PlatformPrivileges | null | undefined) => boolean;
    title: string;
    children: React.ReactNode;
}

export const PrivilegeGate = ({ isRestricted, title, children }: Props) => {
    const { platformPrivileges, privilegesLoading } = useUserContext();

    if (!privilegesLoading && isRestricted(platformPrivileges)) {
        return <AccessRestrictedBlock title={title} />;
    }

    return <>{children}</>;
};
